import { BEGIN_PASSWORD_RESET, INIT_PWD_RESET, RESET_BEGIN_RESET, SUBMIT_PWD_RESET } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface ResetPasswordResponse extends BaseAsyncReducerState{
    found?: boolean;
    user_profile_id?: string | null;
    security_q: string | null; 
    question_id: number | null;
}   

// Define an initial state value for the app
const initialState: ResetPasswordResponse = {
    loading: false,
    error: false,
    found: undefined,
    user_profile_id: null,
    security_q: null,
    question_id: null
}

export function resetPasswordResponseReducer(state = initialState, action: AppAction): ResetPasswordResponse | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case BEGIN_PASSWORD_RESET.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                found: false,
                user_profile_id: null,
                security_q: null
            }
        case BEGIN_PASSWORD_RESET.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }

        case BEGIN_PASSWORD_RESET.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case RESET_BEGIN_RESET:
            return {
                ...state,
                ...initialState
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export interface ResetPassword extends BaseAsyncReducerState {
    resetted?: boolean;
}

const initialStateReset: ResetPassword = {
    loading: false,
    error: false,
    resetted: false,
    success: false,
}

export function resetPasswordFinishReducer(state = initialStateReset, action: AppAction): ResetPassword | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case SUBMIT_PWD_RESET.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                found: false,
                resetted: false

            }
        case SUBMIT_PWD_RESET.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }

        case SUBMIT_PWD_RESET.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case SUBMIT_PWD_RESET.RESET:
            return {
                ...state,
                ...initialStateReset
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export interface InitResetPassword extends BaseAsyncReducerState {
    token?: string | boolean;
    answer_correct?: boolean;
    reset_failed?: boolean
}

const initialStateBeginReset: InitResetPassword = {
    loading: false,
    error: false,
    success: false,
    status: 0,
    token: false,
    answer_correct: true,
    reset_failed: false,
}

export function initPasswordResetReducer(state = initialStateBeginReset, action: AppAction): InitResetPassword | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case INIT_PWD_RESET.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                found: false,

            }
        case INIT_PWD_RESET.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,
            }

        case INIT_PWD_RESET.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case INIT_PWD_RESET.RESET:
            return {
                ...state,
                ...initialStateBeginReset
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}
